import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';
import { getConsent, setConsent, clearAnalyticsCookies } from '../../utils/analytics';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = getConsent();
    if (!hasConsented) {
      // Show banner after 1 second
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    setConsent('accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    setConsent('declined');
    clearAnalyticsCookies();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-icon">
          <FaCookie />
        </div>
        
        <div className="cookie-content">
          <h3>We Value Your Privacy</h3>
          <p>
            We use cookies to enhance your browsing experience, provide personalized content, 
            and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
          </p>
          <p className="cookie-links">
            <a href="/privacy">Privacy Policy</a> • <a href="/terms">Terms of Service</a>
          </p>
        </div>

        <div className="cookie-actions">
          <button className="btn-accept" onClick={handleAccept}>
            Accept All
          </button>
          <button className="btn-decline" onClick={handleDecline}>
            Decline
          </button>
        </div>

        <button className="cookie-close" onClick={handleDecline} aria-label="Close">
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
